import AppThemeProvider from 'components/AppThemeProvider';

export function isMobileDevice() {
  return window.innerWidth < AppThemeProvider.breakpoints.values.md;
}

export function detectNotch() {
  setTimeout(() => {
    const root = document.documentElement;

    // get runtime styles
    const computedStyle = window.getComputedStyle(root);

    // read env values back and check if we have any values
    const hasNotch = [
      computedStyle.getPropertyValue('--notch-top') || '-1',
      computedStyle.getPropertyValue('--notch-right') || '-1',
      computedStyle.getPropertyValue('--notch-bottom') || '-1',
      computedStyle.getPropertyValue('--notch-left') || '-1',
    ]
      .map(parseInt)
      .filter((val) => val > 0)
      .length > 0;

    if (hasNotch) {
      // set <html data-notch="true"> to allow CSS to tweak the display
      root.setAttribute('data-notch', 'true');

      // fire global notch-detected event to let the UI know that happened
      window.dispatchEvent(new CustomEvent('notch-detected', { bubbles: true, cancelable: true }));
    }

    // remove CSS variables
    root.style.removeProperty('--notch-top');
    root.style.removeProperty('--notch-right');
    root.style.removeProperty('--notch-bottom');
    root.style.removeProperty('--notch-left');
  }, 1000);
}

export function getDeviceType() {
  if (window.innerWidth < 768) { return 'MOBILE'; }
  if (window.innerWidth < 1024) { return 'TABLET'; }
  return 'DESKTOP';
}
